export default class CaptchaService {
	private static retryCount: number = 0;

	private static async getCaptchaToken(
		action: string
	): Promise<string | null> {
		try {
			if (!(window as any).grecaptcha) {
				console.error("reCAPTCHA is not loaded yet.");
				return null;
			}

			const token: string = await (window as any).grecaptcha
				.execute(ReCaptchaChallengeKey, { action: action })
				.then((token: string) => {
					return token;
				});

			if (token) {
				return token;
			}

			return null;
		} catch (error) {
			console.error("Error executing reCAPTCHA: ", error);
			return null;
		}
	}

	static async executeCaptcha(action: string): Promise<string | null> {
		try {
			const maxRetryCount: number = 3;
			const retryDelay = [500, 750, 1000];

			while (this.retryCount < maxRetryCount) {
				const recaptchaToken = await this.getCaptchaToken(action);

				if (recaptchaToken?.includes("browser-error")) {
					const delay = retryDelay[this.retryCount] || 1000;
					this.retryCount++;

					await new Promise((resolve) => setTimeout(resolve, delay));
				} else {
					this.retryCount = 0;
					return recaptchaToken;
				}
			}

			this.retryCount = 0;
			return null;
		} catch (e) {
			console.error("Error fetching captcha token:", e);
			return null;
		}
	}
}
